import { defineMessages } from 'react-intl';

export const messages: {
	projectSelectorHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	projectSelectorHeader: {
		id: 'conversation-assistant-message-actions.require-information-tool.project-selector.header',
		defaultMessage: 'Select a project',
		description: 'Title of the project selector header',
	},
});
